import Button from '@material-ui/core/Button';
import classNames from 'classnames';

import { FC, useState } from 'react';
import { IAllocationClient } from '~/services/api/clientAllocation/types';
import DispatchedTypography from '~/ui/pages/Network/components/DispatchedTypography';

import { ReactComponent as CheckCircleOutlineIcon } from '~/ui/assets/images/check_circle_outline.svg';

import styles from '../ViewClientAllocation.module.scss';

interface IProps {
  clients: IAllocationClient[];
  isDispatch: boolean;
}

const ClientCell: FC<IProps> = ({ clients, isDispatch }) => {
  const [showClientsMore, setShowClientsMore] = useState(false);
  const maxAmountToShow = 3;

  return (
    <div className={classNames(styles.cell, { [styles.dispatchedCell]: isDispatch })}>
      <div className={styles.cellWrapper}>
        {(showClientsMore ? clients : [...clients].splice(0, maxAmountToShow)).map(client => (
          <div key={client.id} className={styles.clientCell}>
            {client.resolved && (
              <div className={styles.additionalIcon}>
                <CheckCircleOutlineIcon width={16} height={16} />
              </div>
            )}
            <div className={styles.clientName}>
              {client.firstName} {client.lastName}
            </div>
            <div className={styles.memo}>{client.memo}</div>
            <span className={classNames(styles.dispatch, { [styles.dispatchHidden]: !isDispatch })}>
              <DispatchedTypography />
            </span>
          </div>
        ))}
        {clients.length > maxAmountToShow && (
          <Button
            variant="text"
            onClick={() => setShowClientsMore(prevState => !prevState)}
            className={styles.showMoreButton}
            disableRipple
          >
            {`${showClientsMore ? 'Hide' : 'Show'} More`}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ClientCell;
